// Link/move-contact modal: pick a target customer by search, from suggestions
// or from the customer group, then confirm. Registered at boot so the modal
// also works when loaded lazily into a Turbo Frame.
export default function registerMoveContactModal(Alpine) {
  Alpine.data("moveContactModal", ({ searchUrl, currentCustomerId, groups, suggestions, history }) => ({
    searchUrl,
    currentCustomerId,
    groups: groups || [],
    suggestions: suggestions || [],
    query: "",
    results: [],
    showResults: false,
    loading: false,
    selected: null,
    history: history || "keep",

    async search() {
      if (this.query.length < 2) {
        this.results = [];
        this.showResults = false;
        return;
      }
      this.loading = true;
      this.showResults = true;
      try {
        const resp = await fetch(`${this.searchUrl}?q=${encodeURIComponent(this.query)}`);
        const data = await resp.json();
        this.results = data.filter((c) => c.id !== this.currentCustomerId);
      } finally {
        this.loading = false;
      }
    },

    choose(c) {
      this.selected = c;
      this.showResults = false;
      this.query = "";
      this.results = [];
    },

    clear() {
      this.selected = null;
    }
  }));
}
